
import { useState, useEffect, useCallback } from 'react';
import { User } from '../types';
import { authService } from '../services/auth';

const STORAGE_KEY = 'cn_impersonate_id';

export const useImpersonation = () => {
    const [impersonatedUser, setImpersonatedUser] = useState<User | null>(null);
    const [isLoadingImpersonation, setIsLoadingImpersonation] = useState(false); // Default to false to avoid blocking

    // OPTIMIZATION: Only check storage if we are explicitly entering admin area or upon specific action.
    // However, to keep "F5 refresh" working for an impersonating admin, we can check it,
    // but let's make sure it doesn't block the main auth flow.
    // For now, we will rely on the fact that if you are impersonating, you are already an admin
    // and the main auth has loaded. 
    
    // We remove the auto-effect for now to speed up the critical path.
    // If persistent impersonation across reloads is critical, it should be moved to AuthContext's boot sequence.
    
    /* 
    useEffect(() => {
        const checkStorage = async () => {
            const storedId = sessionStorage.getItem(STORAGE_KEY);
            if (storedId) {
                setIsLoadingImpersonation(true);
                try {
                    const user = await authService.fetchUserProfile(storedId);
                    if (user) {
                        setImpersonatedUser(user);
                    } else {
                        sessionStorage.removeItem(STORAGE_KEY);
                    }
                } catch (e) {
                    console.error("Failed to restore impersonated user", e);
                } finally {
                    setIsLoadingImpersonation(false);
                }
            }
        };
        // checkStorage(); // DISABLED FOR PERFORMANCE
    }, []);
    */

    const startImpersonating = useCallback((user: User) => {
        sessionStorage.setItem(STORAGE_KEY, user.id);
        setImpersonatedUser(user);
    }, []);

    const stopImpersonating = useCallback(() => {
        sessionStorage.removeItem(STORAGE_KEY);
        setImpersonatedUser(null);
    }, []);

    return { 
        impersonatedUser, 
        startImpersonating, 
        stopImpersonating,
        isLoadingImpersonation 
    };
};
